import React from 'react'
import {Auth} from "aws-amplify";
import axios from "axios";
import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Messages} from "primereact/messages";
import {Dialog} from "primereact/dialog";
import {InputText} from "primereact/inputtext";
import {Toolbar} from "primereact/toolbar";

class UpdateRegelwerk extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            isFileUploaded: false,
            dataTableUploadInProgress: false,
            dataTableUploadProgress: 0.0,
            entries: [],
            selectedEntry: null,
            displayDialog: false,
            isLoading: false,
            versions: []
        };

        this.onEntrySelect = this.onEntrySelect.bind(this);
        this.leftToolbarTemplate = this.leftToolbarTemplate.bind(this);
    }

    componentDidMount() {
        //get the current values
        Auth.currentSession()
            .then(session => {
                const axiosConfig = {
                    headers: {'Authorization': session.getIdToken().getJwtToken()}
                };
                axios.get(process.env.REACT_APP_IUCB_REGELWERK_ENDPOINT, axiosConfig)
                    .then(result => {
                        if(result.data && result.data.length > 0) {
                            this.setState({entries: result.data});
                        }
                    })
                    .catch (err => {
                        console.log(err);
                    });
                axios.get(process.env.REACT_APP_IUCB_REGELWERK_VERSIONS_ENDPOINT, axiosConfig)
                    .then(result => {
                        this.setState({versions: result.data});
                    })
                    .catch(err => {
                        console.log(err);
                    });
            })
            .catch (err => {
                console.log(err);
            });
    }

    onEntrySelect(e){
        this.newEntry = false;
        this.setState({
            displayDialog:true,
            entry: Object.assign({}, e.data)
        });
    }

    addNew = () => {
        this.newEntry = true;
        this.setState({
            entry: {selector:'', land: '', marke: '', modell: '', von_km: '', bis_km: '', von_alter:'', bis_alter: '',
                listenpreis: '', pimp_icons: '', motorart: '', percent: '', lokal: ''},
            displayDialog: true
        });
    };

    save = () => {
        let meldungen = this.state.entries;
        if(this.newEntry)
            meldungen.push(this.state.entry);
        else
            meldungen[this.findSelectedCarIndex()] = this.state.entry;

        this.setState({entries:meldungen, selectedEntry:null, entry: null, displayDialog:false});
    };

    findSelectedCarIndex() {
        return this.state.entries.indexOf(this.state.selectedEntry);
    }

    updateProperty(property, value) {
        let car = this.state.entry;
        car[property] = value;
        this.setState({entry: car});
    }

    delete() {
        let index = this.findSelectedCarIndex();
        this.setState({
            entries: this.state.entries.filter((val, i) => i !== index),
            selectedEntry: null,
            entry: null,
            displayDialog: false});
    }

    updateValues = () => {
        //update values by JSON
        Auth.currentSession()
            .then(session => {
                const axiosConfig = {
                    headers: {'Authorization': session.getIdToken().getJwtToken()}
                };

                const data = {
                    updated_values: this.state.entries
                };
                this.setState({isLoading: true});
                axios.post(process.env.REACT_APP_IUCB_REGELWERK_ENDPOINT, data, axiosConfig)
                    .then(result => {
                        this.messages.show({severity: 'success', summary: 'Success', detail: 'Values updated.'});
                        this.setState({isLoading: false});
                    })
                    .catch (err => {
                        this.messages.show({severity: 'error', summary: 'Upload Error', detail: err.message});
                        this.setState({isLoading: false});
                    })
            })
            .catch (err => {
                console.log(err);
            });

    };

    onFileChange = (files) => {
        const selectedFile = files[0];
        if (!selectedFile) {
            return;
        }
        //upload to endpoint
        Auth.currentSession()
            .then(session => {
                const axiosConfig = {
                    headers: {'Authorization': session.getIdToken().getJwtToken()}
                };
                const params = {
                    file_identifier: 'regelwerk'
                };

                //retrive pre-signed URL
                axios.post(process.env.REACT_APP_IUCB_UPLOAD_ENDPOINT, params, axiosConfig)
                    .then(result => {
                        const url = result.data.upload_url;
                        // after receiving the signed URL an upload via put is possible
                        const axiosUploadConfig = {
                            headers: {'content-disposition': 'Attachment', 'Content-Type': selectedFile.type},
                            onUploadProgress: (progressEvent) => {
                                const totalLength = progressEvent.lengthComputable ? progressEvent.total : selectedFile.size;
                                if (totalLength !== null) {
                                    this.setState({dataTableUploadProgress: Math.round((progressEvent.loaded * 100) / totalLength)});
                                }
                            }
                        };
                        axios.put(url, selectedFile, axiosUploadConfig)
                            .then(result => {
                                this.messages.show({severity: 'success', summary: 'Success', detail: 'File is completely uploaded!'});

                                this.setState({
                                    dataTableUploadInProgress: false,
                                    dataTableUploadProgress: 0.0,
                                    isFileUploaded: true
                                });
                            })
                            .catch(err => {
                                this.setState({
                                    dataTableUploadInProgress: false,
                                    dataTableUploadProgress: 0.0
                                });
                                this.messages.show({severity: 'error', summary: 'Upload Error', detail: err.message});
                            });
                    })
                    .catch(err => {
                        console.log(err);
                    })
            })
            .catch (err => {
                console.log(err);
            });
    };

    leftToolbarTemplate() {
        return (
            <React.Fragment>
                <Button type="button" className="p-mr-2 p-d-inline-block" label="Add" icon="pi pi-plus" onClick={() => this.addNew()}/>
            </React.Fragment>
        )
    }

    render () {
        let paginatorLeft = <Button icon="pi pi-refresh"/>;
        let paginatorRight = <Button icon="pi pi-cloud-upload" />;


        let dialogFooter = <div className="ui-dialog-buttonpane p-clearfix">
            <Button label="Delete" icon="pi pi-times" onClick={() => this.delete()}/>
            <Button label="Save" icon="pi pi-check" onClick={() => this.save()}/>
        </div>;

        return (
            <main className="o-page-wrap">
                <div>
                    <h1>Ruleset</h1>
                    <p>Please use the table or the file upload function to update the values. If you provide a CSV file, please refresh the page to see the changes.</p>
                    <h2>Current Values</h2>

                    <DataTable value={this.state.entries} style={{width: '100%'}} scrollable={true}
                               paginator={true} paginatorLeft={paginatorLeft} paginatorRight={paginatorRight}
                               selectionMode="single" selection={this.state.selectedEntry}
                               onSelectionChange={e => this.setState({selectedEntry: e.value})}
                               onRowSelect={this.onEntrySelect}
                               rows={20} rowsPerPageOptions={[20,50,100]}>
                        <Column field="selector" header="MBV" style={{width:'100px'}} sortable={true} filter={true}/>
                        <Column field="land" header="Country" style={{width:'100px'}} sortable={true} filter={true}/>
                        <Column field="marke" header="Brand" style={{width:'80px'}} />
                        <Column field="modell" header="Model" style={{width:'150px'}} />
                        <Column field="von_km" header="From KM" style={{width:'100px'}} />
                        <Column field="bis_km" header="To KM" style={{width:'100px'}} />
                        <Column field="von_alter" header="From Age" style={{width:'100px'}} />
                        <Column field="bis_alter" header="To Age" style={{width:'100px'}} />
                        <Column field="listenpreis" header="Listprice" style={{width:'80px'}} />
                        <Column field="pimp_icons" header="Pimp Icons" style={{width:'100px'}} />
                        <Column field="motorart" header="Engine Type" style={{width:'80px'}} />
                        <Column field="percent" header="Percent" style={{width:'80px'}} />
                        <Column field="lokal" header="Local" style={{width:'80px'}} />
                    </DataTable>

                    <Toolbar className="p-mb-4" left={this.leftToolbarTemplate} ></Toolbar>

                    <br />
                    <button type="button" className="c-btn" onClick={ () => this.updateValues() }
                            disabled={this.state.isLoading}>
                        <span className="c-btn__text">Save and Update</span>
                        {this.state.isLoading ?
                            <div className="c-spinner c-spinner--small">
                                <svg>
                                    <circle className="c-spinner__indicator" cx="9" cy="9" r="8" fill="none"/>
                                </svg>
                            </div>
                            : null
                        }
                    </button>

                    <Messages ref={(el) => this.messages = el}></Messages>

                    <Dialog visible={this.state.displayDialog} width="300px" header="Entry Details" modal={true} footer={dialogFooter} onHide={() => this.setState({displayDialog: false})}>
                        {
                            this.state.entry &&

                            <div className="p-grid p-fluid">
                                <div className="p-col-4" style={{padding:'.75em'}}><label htmlFor="selector">MBV</label></div>
                                <div className="p-col-8" style={{padding:'.5em'}}>
                                    <InputText id="selector" onChange={(e) => {this.updateProperty('selector', e.target.value)}} value={this.state.entry.selector}/>
                                </div>


                                <div className="p-col-4" style={{padding:'.75em'}}><label htmlFor="land">Country</label></div>
                                <div className="p-col-8" style={{padding:'.5em'}}>
                                    <InputText id="land" onChange={(e) => {this.updateProperty('land', e.target.value)}} value={this.state.entry.land}/>
                                </div>

                                <div className="p-col-4" style={{padding:'.75em'}}><label htmlFor="marke">Brand</label></div>
                                <div className="p-col-8" style={{padding:'.5em'}}>
                                    <InputText id="marke" onChange={(e) => {this.updateProperty('marke', e.target.value)}} value={this.state.entry.marke}/>
                                </div>

                                <div className="p-col-4" style={{padding:'.75em'}}><label htmlFor="modell">Model</label></div>
                                <div className="p-col-8" style={{padding:'.5em'}}>
                                    <InputText id="modell" onChange={(e) => {this.updateProperty('modell', e.target.value)}} value={this.state.entry.modell}/>
                                </div>

                                <div className="p-col-4" style={{padding:'.75em'}}><label htmlFor="von_km">From KM</label></div>
                                <div className="p-col-8" style={{padding:'.5em'}}>
                                    <InputText id="von_km" onChange={(e) => {this.updateProperty('von_km', e.target.value)}} value={this.state.entry.von_km}/>
                                </div>

                                <div className="p-col-4" style={{padding:'.75em'}}><label htmlFor="bis_km">To KM</label></div>
                                <div className="p-col-8" style={{padding:'.5em'}}>
                                    <InputText id="bis_km" onChange={(e) => {this.updateProperty('bis_km', e.target.value)}} value={this.state.entry.bis_km}/>
                                </div>

                                <div className="p-col-4" style={{padding:'.75em'}}><label htmlFor="von_alter">From Age</label></div>
                                <div className="p-col-8" style={{padding:'.5em'}}>
                                    <InputText id="von_alter" onChange={(e) => {this.updateProperty('von_alter', e.target.value)}} value={this.state.entry.von_alter}/>
                                </div>

                                <div className="p-col-4" style={{padding:'.75em'}}><label htmlFor="bis_alter">To Age</label></div>
                                <div className="p-col-8" style={{padding:'.5em'}}>
                                    <InputText id="bis_alter" onChange={(e) => {this.updateProperty('bis_alter', e.target.value)}} value={this.state.entry.bis_alter}/>
                                </div>

                                <div className="p-col-4" style={{padding:'.75em'}}><label htmlFor="listenpreis">Listprice</label></div>
                                <div className="p-col-8" style={{padding:'.5em'}}>
                                    <InputText id="listenpreis" onChange={(e) => {this.updateProperty('listenpreis', e.target.value)}} value={this.state.entry.listenpreis}/>
                                </div>

                                <div className="p-col-4" style={{padding:'.75em'}}><label htmlFor="pimp_icons">Pimp Icons</label></div>
                                <div className="p-col-8" style={{padding:'.5em'}}>
                                    <InputText id="pimp_icons" onChange={(e) => {this.updateProperty('pimp_icons', e.target.value)}} value={this.state.entry.pimp_icons}/>
                                </div>

                                <div className="p-col-4" style={{padding:'.75em'}}><label htmlFor="motorart">Engine Type</label></div>
                                <div className="p-col-8" style={{padding:'.5em'}}>
                                    <InputText id="motorart" onChange={(e) => {this.updateProperty('motorart', e.target.value)}} value={this.state.entry.motorart}/>
                                </div>

                                <div className="p-col-4" style={{padding:'.75em'}}><label htmlFor="percent">Percentage</label></div>
                                <div className="p-col-8" style={{padding:'.5em'}}>
                                    <InputText id="percent" onChange={(e) => {this.updateProperty('percent', e.target.value)}} value={this.state.entry.percent}/>
                                </div>

                                <div className="p-col-4" style={{padding:'.75em'}}><label htmlFor="lokal">Local</label></div>
                                <div className="p-col-8" style={{padding:'.5em'}}>
                                    <InputText id="lokal" onChange={(e) => {this.updateProperty('lokal', e.target.value)}} value={this.state.entry.lokal}/>
                                </div>
                            </div>
                        }
                    </Dialog>
                    <h2>Upload Values as CSV</h2>
                    <p>Please upload a CSV file with the same structure as the table above.</p>
                    <label htmlFor="file-upload" className="c-upload"
                           data-mouseover-text="This is the mouseover variant of the upload container">
                        <input className="c-upload__input" type="file" id="file-upload" onChange={ (e) => this.onFileChange(e.target.files) } />

                        <p className="c-upload__description">
                            <span>Click on this container for file uploads</span>
                            <span>or</span>
                        </p>

                        <div className="c-upload__actions">
                            <label className="c-upload__button  c-btn" htmlFor="file-upload">
                                <span>click here</span>
                            </label>
                        </div>
                    </label>
                    <h2>Versions</h2>
                    <DataTable value={this.state.versions} style={{width: '100%'}}
                               paginator={true}
                               rows={20} rowsPerPageOptions={[20,50,100]}>
                        <Column field="filename" header="Filename" style={{width:'100px'}} />
                        <Column field="content_length" header="File Size (Bytes)" style={{width:'100px'}} />
                        <Column field="last_modified" header="Last Modified" style={{width:'100px'}} />
                    </DataTable>
                </div>
            </main>
        )
    }
}
export default UpdateRegelwerk;
